import { atom } from "recoil";

export const refreshListArticle = atom({
    key: "refreshListArticle",
    default: false,
  });
